export const APP_INSIGHTS_EVENT_LOG = {
  // [EL] = Event Log
  TRANSLATE_FEATURE: `[EL] MISSING FEATURE TRANSLATION`,
};
